import React from 'react';
import { FaLinkedin, FaGithub } from 'react-icons/fa';

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className='w-full bg-[#03070e] text-gray-500 py-8'>
      <div className='max-w-[1000px] mx-auto px-4 flex flex-col sm:flex-row items-center justify-between gap-4'>
        <p className='text-sm'>
          © {year} <span className='text-[#ffd700]'>Riz Mark Corpuz</span>. All rights reserved.
        </p>
        <div className='flex gap-6 items-center'>
          <a
            href='https://www.linkedin.com/in/riz-mark-corpuz/'
            target='_blank'
            rel='noopener noreferrer'
            className='hover:text-[#ffd700] transition-colors duration-200'
            aria-label='LinkedIn'
          >
            <FaLinkedin size={22} />
          </a>
          <a
            href='https://github.com/rizmarkcorpuz'
            target='_blank'
            rel='noopener noreferrer'
            className='hover:text-[#ffd700] transition-colors duration-200'
            aria-label='GitHub'
          >
            <FaGithub size={22} />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
